import React, { useEffect } from 'react';
import { Globe, Building2 } from 'lucide-react';
import PageShell from '../common/PageShell.jsx';
import PageHero from '../common/PageHero.jsx';

const Partners = () => {
  useEffect(() => {
    document.title = 'Franchise | Eco World Capital';
  }, []);

  const domesticPartners = [
    {
      name: 'Bonanza Portfolio Ltd.',
      openAccountLink: 'https://l.bigul.co/t7hrecu',
      loginLink: 'https://trading.bigul.co/#!/app',
    },
    {
      name: 'Alice Blue',
      openAccountLink: 'https://ekyc.aliceblueonline.com/?source=WMUM1772',
      loginLink: 'https://ant.aliceblueonline.com/',
    },
  ];

  const globalPartners = [
    { name: 'Exness Technologies Ltd' },
    { name: 'Octa FX' },
  ];

  const PartnerCard = ({ partner, icon: Icon }) => {
    const hasLinks = partner.openAccountLink && partner.loginLink;

    return (
      <div className="glass-card p-8 relative overflow-hidden group">
        <div className="absolute top-0 left-0 w-full h-1/2 bg-gradient-to-b from-brand-cream/20 to-transparent pointer-events-none" aria-hidden="true" />

        <div className="relative z-10 text-center">
          <div className="w-20 h-20 mx-auto bg-white rounded-2xl flex items-center justify-center mb-6 shadow-md text-brand-primary transform group-hover:scale-105 transition-transform">
            <Icon size={32} aria-hidden="true" />
          </div>
          <h3 className="text-2xl font-extrabold text-brand-gold tracking-wide mb-8">{partner.name}</h3>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {hasLinks ? (
              <>
                <a href={partner.openAccountLink} target="_blank" rel="noopener noreferrer" className="btn-primary w-full sm:w-auto">
                  <span className="sm:hidden">Open Account</span>
                  <span className="hidden sm:inline">Opening Account Link</span>
                </a>
                <a href={partner.loginLink} target="_blank" rel="noopener noreferrer" className="btn-secondary w-full sm:w-auto">
                  <span className="sm:hidden">Login</span>
                  <span className="hidden sm:inline">Account Login Link</span>
                </a>
              </>
            ) : (
              <p className="text-sm font-semibold text-brand-cream-muted italic py-2">Links coming soon</p>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <PageShell>
      <PageHero badge="ECO WORLD CAPITAL (EWC) IS" title="Franchise and Business Associates OF" />

      <section className="py-24 px-6 md:px-12 bg-black/10 border-y border-white/20 backdrop-blur-sm">
        <div className="max-w-6xl mx-auto">
          <div className="mb-20">
            <div className="grid md:grid-cols-2 gap-8">
              {domesticPartners.map((partner, idx) => (
                <PartnerCard key={idx} partner={partner} icon={Building2} />
              ))}
            </div>
          </div>

          <div>
            <div className="mb-8 p-4 rounded-2xl bg-brand-gold/15 border border-brand-gold/40 text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-extrabold text-brand-cream leading-snug">
                Introducing Broker (IB) and Global Market Partners
              </h2>
              <p className="mt-3 text-base font-bold text-brand-gold-light tracking-wide">
                (NOT APPLICABLE FOR INDIAN RESIDENT)
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {globalPartners.map((partner, idx) => (
                <PartnerCard key={idx} partner={partner} icon={Globe} />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 px-6 md:px-12 text-center max-w-3xl mx-auto">
        <p className="text-brand-cream-muted font-medium text-sm md:text-base border border-brand-cream/20 bg-brand-cream/5 rounded-2xl py-4 px-6 backdrop-blur-sm inline-block shadow-sm">
          Along with other regulated and recognized financial market participants and service providers.
        </p>
      </section>
    </PageShell>
  );
};

export default Partners;
